import { getEnv } from 'config/Config';
import { eaFetch, objToQueryString } from 'services/common/ApiUtils';

export async function sendEvRequest(
  accountId,
  thirdpartyId,
  evRequest,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `account/${accountId}/thirdparties/${thirdpartyId}/ecovadis`,
    evRequest
  );
}

export async function fetchExistingEvaluation(
  accountId,
  thirdpartyId,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/thirdparties/${thirdpartyId}/ecovadis/fetch-existing`
  );
}

export async function verifyEvDataExistsForThirdparty(
  accountId,
  thirdpartyId,
  dispatch,
  signal
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/thirdparties/${thirdpartyId}/ecovadis/verify`,
    null,
    null,
    null,
    signal
  );
}

export async function getEvHistory(accountId, thirdpartyId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/thirdparties/${thirdpartyId}/ecovadis/history`
  );
}


export async function getEcovadisScoresCount(accountId, ecovadisScoresFilters, dispatch, signal) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/risks/ecovadis?${objToQueryString(ecovadisScoresFilters)}`,
    null, null, null, signal
  );
}

export async function stopEvaluation(
  accountId,
  thirdpartyId,
  dispatch,
  signal
) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'POST',
    `account/${accountId}/thirdparties/${thirdpartyId}/ecovadis/stop`,
    null,
    null,
    null,
    signal
  );
}

export async function getEcovadisThirdpartyDocument(
  accountId,
  thirdpartyId,
  dispatch
) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `account/${accountId}/thirdparties/${thirdpartyId}/ecovadis/document`
  );
}